export default function Footer() {
  return (
    <footer>
      coded by{" "}
      <a href="https://www.linkedin.com/in/oussama-ayadi1/">oussama ayadi</a>
    </footer>
  );
}
